import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ResponseCompanyDto } from 'features/company/types/dtos';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';

export type CompaniesQueryParams = BaseQueryParams;

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseCompanyDto>, CompaniesQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const companiesResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.COMPANIES, _arg));

            if (companiesResponse.error) {
                return { error: companiesResponse.error };
            }

            const companies = companiesResponse.data as PaginatedResponse<ResponseCompanyDto>;

            return {
                data: companies,
            };
        },
        providesTags: [{ type: 'companies', id: 'GET' }],
    });
